import cn from 'classnames'
import { observer } from 'mobx-react-lite'

import { GutterComments } from '#components/GutterComments'
import { GutterLeft } from '#components/GutterLeft'
import { ILoadedScript } from '#state'

import styles from './EditorHost.module.scss'

type EditorHostProps = {
  script: ILoadedScript
  isDisconnected: boolean
  pmHostRef: (node: HTMLDivElement | null) => void
}

export const EditorHost = observer(function EditorHost({
  script,
  isDisconnected,
  pmHostRef,
}: EditorHostProps) {
  const isCreatingComment = script.pmEditor.hasUnsavedComment
  const isEmptySelection = !!script.pmEditor.selection?.empty
  const isEmptyDoc = script.pmEditor.docInfo?.empty

  const classes = cn(styles.pmHostWrapper, {
    // don't show script until we have the right styles loaded.
    // ONLY makes the script invisible, doesn't hide any error toasts/loaders
    [styles.safelyHidden]: !script,
    [styles.disconnected]: isDisconnected,
    [styles.isCreatingComment]: isCreatingComment,
    [styles.emptySelection]: isEmptySelection,
    'is-empty-prose-doc': isEmptyDoc,
    [styles.showLayoutLines]: script.showLayoutLines,
  })

  return (
    <div id="pm-host-wrapper" className={classes}>
      <div className="c-editor">
        <div className="c-editor__gutterleft" id="editor-gutter-left"></div>
        <div className="c-editor__overlay"></div>
        <div className="l-box l-box--column c-editor-banner">
          <div id="editor" ref={pmHostRef}></div>
        </div>
        <div id="editor-gutter-right" className="c-editor__gutterright"></div>
        <GutterLeft script={script} />
        {script.canAddComments && <GutterComments script={script} />}
        <div data-blurred-cursor className={styles.blurredCursor} />
      </div>
    </div>
  )
})
